<template>
  <div class="video_marterial">
    <div class="wrapper">
        <h1>{{$t('other.a3177')}}</h1>
        <div>
            <div class="item">
                
                {{$t('other.a3178')}}：<el-input style="width:450px;margin-right:20px;" size="medium" v-model="linkUrl" :placeholder="$t('other.a542')"></el-input>
                <el-button type="primary" size="medium" @click="CopyText()">{{$t('other.a1356')}}</el-button>
            </div>
            <div class="item">
                <span>{{$t('other.a3179')}}：0t5s </span>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return {
            linkUrl:'https://pan.baidu.com/s/1xNG6Gsh_f4pXXqs9uG_3Rg?pwd=0t5s'
        }
    },

methods:{
    CopyText(){
        let _input = document.createElement("input");   // 直接构建input
        　　_input.value = this.linkUrl;  // 设置内容
        　　document.body.appendChild(_input);    // 添加临时实例
        　　_input.select();   // 选择实例内容
        　　document.execCommand("Copy");   // 执行复制
        　　this.$message.success(this.$t('other.a544'))
        　　document.body.removeChild(_input); // 删除临时实例
    },

}
}

</script>
<style lang="scss" scoped>
.video_marterial{
    width: 100%;
    height: calc(100vh - 60px);
    
    position: relative;

    .wrapper{
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto auto;
        width: 70%;
        height: 200px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .item{
            font-size: 20px;
            margin: 40px 0;
        }
    }
}
</style>